import { Button } from '@design-system/button';
import { Dialog, DialogContent, DialogTrigger } from '@design-system/dialog';
import { BoxAdd, Crown1, Setting2 } from 'iconsax-react';
import AddonsDialog from '../dialogs/addons-dialog';
import { useGetCustomerPortal } from '../services/get-customer-portal';
import useCheckSubscription from '@shared/hooks/use-check-subscription';
import { useNavigate } from 'react-router-dom';
import { createRoute, PATHS } from '@src/core/router/paths';

const BillingActions = () => {
  const navigate = useNavigate();

  const { data } = useGetCustomerPortal();
  const { isFreeTrial } = useCheckSubscription();

  const handleManageSubscription = () => {
    if (data?.url) {
      window.open(data.url, '_blank');
    }
  };

  return (
    <div className='flex items-center gap-2'>
      {!isFreeTrial ? (
        <>
          <Dialog>
            <DialogTrigger>
              <Button
                variant='primaryOutline'
                size={'sm'}
              >
                <BoxAdd />
                Adds-on
              </Button>
            </DialogTrigger>
            <DialogContent className='max-w-11/12'>
              <AddonsDialog />
            </DialogContent>
          </Dialog>
          <Button
            variant='warning'
            size={'sm'}
            onClick={handleManageSubscription}
            disabled={!data?.url}
          >
            <Setting2 />
            Manage Subscription
          </Button>
        </>
      ) : (
        <Button
          variant='warning'
          size={'sm'}
          onClick={() =>
            navigate(
              `${createRoute(PATHS.SETTINGS_BILLING_A_SUBSCRIPTION)}?tab=upgrade`
            )
          }
        >
          <Crown1 />
          Upgrade
        </Button>
      )}
    </div>
  );
};

export default BillingActions;
